"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function useForceUpdate() {
    const [tick, forceUpdate] = (0, react_1.useReducer)((s) => (s > 1000 ? 0 : s + 1), 0);
    const acknowledgeUpdate = (0, react_1.useCallback)(num => num > 0, []);
    return { tick, forceUpdate, acknowledgeUpdate };
}
exports.default = useForceUpdate;
